import DashboardLayout from "@/components/layouts/DashboardLayout";
import AllocationsPanel from "@/panel/dashboard/allocations/AllocationsPanel";
import DashboardBuyPanels from "@/panel/dashboard/buypanels/DashboardBuyPanels";
import ChangePassword from "@/panel/dashboard/changePassword/ChangePassword";
import ContactPanel from "@/panel/dashboard/contact/ContactPanel";
import DashboardPanel from "@/panel/dashboard/DashboardPanel";
import MyLocationPanel from "@/panel/dashboard/location/MyLocationPanel";
import MyOrdersPanel from "@/panel/dashboard/orders/MyOrdersPanel";
import MyProfile from "@/panel/dashboard/profile/ProfilePanel";
import TrackerPanel from "@/panel/dashboard/progress/TrackerPanel";
import TrackerPanelPrevious from "@/panel/TrackerPanel-previous";
import TermsPanel from "@/panel/dashboard/terms/TermsPanel";
import OrderTracker from "@/panel/order-tracker/OrderTracker";
import { Routes, Route, Navigate } from "react-router";

export default function DashboardPage() {
  return (
    <DashboardLayout>
      <Routes>
        <Route index element={<DashboardPanel />} />
        <Route path="order-tracker" element={<OrderTracker />} />
        <Route path="tracker" element={<TrackerPanel />} />
        <Route path="oldtracker" element={<TrackerPanelPrevious />} />
        <Route path="locations" element={<MyLocationPanel />} />
        <Route path="terms" element={<TermsPanel />} />
        <Route path="allocations" element={<AllocationsPanel />} />
        <Route
          path="allocations/gas"
          element={<AllocationsPanel account="gas" />}
        />
        <Route
          path="allocations/electricity"
          element={<AllocationsPanel account="electricity" />}
        />
        <Route path="allocations/bank" element={<AllocationsPanel account="bank" />} />
        <Route path="orders" element={<MyOrdersPanel />} />
        <Route path="profile" element={<MyProfile />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="buypanels/*" element={<DashboardBuyPanels />} />
        <Route path="contact" element={<ContactPanel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
